import React from 'react'
import PropTypes from 'prop-types'

import Link from '@material-ui/core/Link'

export default function PanelFieldLinkValue(props) {
  const { value, valueLabel } = props

  return (
    <Link href={value} target="_blank">
      {valueLabel ?? value}
    </Link>
  )
}

PanelFieldLinkValue.propTypes = {
  value: PropTypes.string,
}
